import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { toQueryString } from '../../../../util';

const Channel = ({ channel, pathName, queryParams }) => (
	<div>
		<Link
			id={`channel-navigation-btn-${channel.id}`}
			to={{ pathname: `${pathName}/channels/${channel.id}`, search: toQueryString(queryParams) }}
		>
			{channel.name}
		</Link>
	</div>
);

Channel.propTypes = {
	pathName: PropTypes.string.isRequired,
};

Channel.defaultProps = {};

export default Channel;



// WEBPACK FOOTER //
// ./src/ui/channels/children/channel/Channel.component.js